// extracted by mini-css-extract-plugin
export default {"input":"input_input__Dwsco","error":"input_error__jaq7b"};